/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RenderedBoxChildrenInner } from './RenderedBoxChildrenInner';
import {
    RenderedBoxChildrenInnerFromJSON,
    RenderedBoxChildrenInnerFromJSONTyped,
    RenderedBoxChildrenInnerToJSON,
    RenderedBoxChildrenInnerToJSONTyped,
} from './RenderedBoxChildrenInner';
import type { RenderedBox } from './RenderedBox';
import {
    RenderedBoxFromJSON,
    RenderedBoxFromJSONTyped,
    RenderedBoxToJSON,
    RenderedBoxToJSONTyped,
} from './RenderedBox';
import type { UiComponent } from './UiComponent';
import {
    UiComponentFromJSON,
    UiComponentFromJSONTyped,
    UiComponentToJSON,
    UiComponentToJSONTyped,
} from './UiComponent';

/**
 * Root of the rendered layout tree
 * @export
 * @interface Element
 */
export interface Element {
    /**
     * 
     * @type {string}
     * @memberof Element
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof Element
     */
    title?: string;
    /**
     * core-ui Box props / CSS style properties (e.g. flexBasis, minWidth)
     * @type {{ [key: string]: any; }}
     * @memberof Element
     */
    cssProperties?: { [key: string]: any; };
    /**
     * Nested rendered nodes
     * @type {Array<RenderedBoxChildrenInner>}
     * @memberof Element
     */
    children?: Array<RenderedBoxChildrenInner>;
    /**
     * 
     * @type {any}
     * @memberof Element
     */
    content: any | null;
    /**
     * 
     * @type {string}
     * @memberof Element
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Element
     */
    metricName?: string;
}

/**
 * Check if a given object implements the Element interface.
 */
export function instanceOfElement(value: object): value is Element {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function ElementFromJSON(json: any): Element {
    return ElementFromJSONTyped(json, false);
}

export function ElementFromJSONTyped(json: any, ignoreDiscriminator: boolean): Element {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'title': json['title'] == null ? undefined : json['title'],
        'cssProperties': json['cssProperties'] == null ? undefined : json['cssProperties'],
        'children': json['children'] == null ? undefined : ((json['children'] as Array<any>).map(RenderedBoxChildrenInnerFromJSON)),
        'content': json['content'],
        'id': json['id'] == null ? undefined : json['id'],
        'metricName': json['metric_name'] == null ? undefined : json['metric_name'],
    };
}

export function ElementToJSON(json: any): Element {
    return ElementToJSONTyped(json, false);
}

export function ElementToJSONTyped(value?: Element | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'title': value['title'],
        'cssProperties': value['cssProperties'],
        'children': value['children'] == null ? undefined : ((value['children'] as Array<any>).map(RenderedBoxChildrenInnerToJSON)),
        'content': value['content'],
        'id': value['id'],
        'metric_name': value['metricName'],
    };
}

